import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import EventHeaderPage from "components/EventHeaderPage"
import { ListAside, ListAsideTypes } from "components/list-aside"
import SessionsFiltersBar from "components/sessions/SessionsFiltersBar"
import SessionsFiltersForm from "components/sessions/SessionsFiltersForm"
import { SessionsList } from "components/sessions/SessionsList"
import ConventionSession from "models/convention-api/v1/ConventionSession"
import { useState } from "react"
import Sticky from "react-stickynode"

const useStyles = makeStyles()(
  (theme) => ({
    mainContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      paddingLeft: theme.spacing(1.7),
      paddingRight: theme.spacing(1.7),
      [theme.breakpoints.up("md")]: {
        paddingLeft: 40,
        paddingRight: 40,
      },
    },
    contentContainer: {
      display: "flex",
      flexDirection: "column",
      paddingBottom: theme.spacing(7),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        marginTop: theme.spacing(5),
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        marginTop: 0,
      },
    },
    listAsideContainer: {
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        marginBottom: "16px",
      },
      [theme.breakpoints.up("md")]: {
        width: "25%",
        marginBottom: 0,
      },
    },
    sessionsContainer: {
      display: "flex",
      flexDirection: "column",
      paddingLeft: 0,
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: "75%",
        paddingLeft: theme.spacing(5),
        paddingTop: 0,
      },
    },
    sessionsListContainer: {
      marginTop: theme.spacing(5),
      [theme.breakpoints.up("md")]: {
        marginTop: 0,
      },
    },
  })
)

interface ISessionsNavV2 {
  sessionsCount: number
  eventHeaderPageName: string
  eventHeaderPageText: string
  sessions: ConventionSession[]
  userSessionIds: Record<string, boolean>
  isLoading: boolean
  isReady: boolean
  loadMore: () => void
  hasMore: boolean
  activeFiltersCount: number
  onSetReminder: (sessionId: string) => void
  onRemoveReminder: (sessionId: string) => void
}

export const SessionsNavV2 = (props: ISessionsNavV2) => {
  const {
    sessionsCount,
    eventHeaderPageName,
    eventHeaderPageText,
    sessions,
    loadMore,
    hasMore,
    activeFiltersCount,
    isLoading,
    isReady,
    userSessionIds,
    onSetReminder,
    onRemoveReminder,
  } = props
  const { classes } = useStyles()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  return (
    <Box className={classes.mainContainer}>
      <EventHeaderPage
        headingName={eventHeaderPageName}
        resultsCount={sessionsCount}
        headerText={eventHeaderPageText}
      />
      <Box className={classes.contentContainer}>
        <Box className={classes.listAsideContainer}>
          <ListAside
            setIsDrawerOpen={setIsDrawerOpen}
            isDrawerOpen={isDrawerOpen}
            type={ListAsideTypes.LIVESESSIONS}>
            <SessionsFiltersForm />
          </ListAside>
        </Box>
        <Box className={classes.sessionsContainer}>
          {/*@ts-ignore children type error occurs because of upgrading to React 18*/}
          <Sticky innerZ={40} enabled={true} top={0}>
            <SessionsFiltersBar
              setIsDrawerOpen={setIsDrawerOpen}
              isDrawerOpen={isDrawerOpen}
              filtersCount={activeFiltersCount}
              resultsCount={sessionsCount}
            />
          </Sticky>
          <Box className={classes.sessionsListContainer}>
            <SessionsList
              onSetReminder={onSetReminder}
              onRemoveReminder={onRemoveReminder}
              sessions={sessions}
              userSessionIds={userSessionIds}
              isLoading={isLoading}
              isReady={isReady}
              onLoadMore={loadMore}
              hasMore={hasMore}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
